import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import { toAbsoluteUrl, KTIcon } from '../../../helpers'
import { useThemeMode, ThemeModeType } from '../theme-mode/ThemeModeProvider'

const HeaderUserMenu: FC = () => {
  const { currentUser, logout } = useAuth()
  const { menuMode, updateMode, updateMenuMode } = useThemeMode()

  const dismissMenu = () => {
    // Basic dismissal
    window.dispatchEvent(new CustomEvent('ccs-close-header-dropdowns', { detail: 'force' }))
  }

  const switchMode = (_mode: ThemeModeType) => {
    updateMenuMode(_mode)
    updateMode(_mode)
  }

  // RBAC: Global Settings hanya tampil jika diberikan akses module 'global_settings' oleh Admin
  // (dan tidak untuk user client atau sub-user)
  const roleName = currentUser?.role?.name?.toUpperCase()
  const allowedMenus = (currentUser?.role?.allowedMenus || '')
    .split(',')
    .map((m: string) => m.trim().toLowerCase())
  const canAccessGlobalSettings =
    !currentUser?.clientId &&
    (roleName === 'SUPERADMIN' || allowedMenus.includes('global_settings'))

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded fw-bold ccs-header-user-menu show'
      data-kt-menu='true'
    >
      {/* Profil User */}
      <div className='d-flex align-items-center gap-3 px-1 py-1'>
        <div className='ccs-user-avatar-styled ccs-user-menu-avatar flex-shrink-0 d-flex align-items-center justify-content-center text-white'>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white">
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <span className='ccs-avatar-online-dot' title='Status: Active'></span>
        </div>

        <div className='d-flex flex-column overflow-hidden me-1 flex-grow-1'>
          <div className='ccs-user-menu-name d-flex align-items-center gap-2 text-truncate'>
            <span>{currentUser?.name || 'Admin'}</span>
          </div>
          <span className='ccs-user-menu-email text-truncate mt-0.5'>
            {currentUser?.email || 'admin@smartcall.id'}
          </span>
        </div>
      </div>

      <div className='ccs-menu-divider'></div>

      {/* Switch Mode (Theme Mode) */}
      <div>
        <div className='ccs-user-menu-section-title mb-2'>
          Switch Mode
        </div>
        <div className='ccs-user-menu-theme-track d-flex align-items-center justify-content-between gap-1'>
          <button
            type='button'
            className={`ccs-user-menu-theme-btn flex-grow-1 ${menuMode === 'light' ? 'active' : ''}`}
            onClick={() => switchMode('light')}
          >
            <KTIcon iconName='night-day' className='fs-5 ccs-theme-icon-light' />
            <span>Light</span>
          </button>

          <button
            type='button'
            className={`ccs-user-menu-theme-btn flex-grow-1 ${menuMode === 'dark' ? 'active' : ''}`}
            onClick={() => switchMode('dark')}
          >
            <KTIcon iconName='moon' className='fs-5 ccs-theme-icon-dark' />
            <span>Dark</span>
          </button>

          <button
            type='button'
            className={`ccs-user-menu-theme-btn flex-grow-1 ${menuMode === 'system' ? 'active' : ''}`}
            onClick={() => switchMode('system')}
          >
            <KTIcon iconName='screen' className='fs-5 ccs-theme-icon-system' />
            <span>System</span>
          </button>
        </div>
      </div>

      <div className='ccs-menu-divider'></div>

      {/* Navigasi Links */}
      <div className='d-flex flex-column gap-1'>
        <Link to={'/apps/profile'} onClick={dismissMenu} className='ccs-user-menu-link gap-3'>
          <KTIcon iconName='profile-circle' className='ccs-nav-icon-profile' />
          <span>My Profile</span>
        </Link>

        {canAccessGlobalSettings && (
          <Link to='/settings' onClick={dismissMenu} className='ccs-user-menu-link gap-3'>
            <KTIcon iconName='setting-2' className='ccs-nav-icon-settings' />
            <span>Global Settings</span>
          </Link>
        )}
      </div>

      <div className='ccs-menu-divider'></div>

      {/* Action Buttons */}
      <div className='d-flex flex-column gap-2'>
        <button
          type='button'
          onClick={logout}
          className='btn ccs-user-menu-logout-btn d-flex align-items-center justify-content-center gap-2 w-100'
        >
          <KTIcon iconName='entrance-left' className='fs-4' />
          <span>Sign Out</span>
        </button>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
